export default "__VITE_ASSET__41959ff7__"